import axios from 'axios'
import qs from 'qs'

// const TAG = 'HTTP'
let Axios = axios.create({
  timeout: 20000
})

/**
 * post请求
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 */
function post (url, params) {
  return Axios.post(url, qs.stringify(params), {
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  }).catch(e => {
    return Promise.reject({
      code: -1,
      msg: 'network error'
    })
  })
}

/**
 * get请求
 * @param {string} url 请求地址
 */
function get (url) {
  return axios
    .get(url, {
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
    .catch(e => {
      alert('network error')
      return Promise.reject({
        code: -1,
        msg: 'network error'
      })
    })
}

/**
 * 并发的发多个请求
 * @param {array} promises
 * @param {function} success
 */
function all (promises, success) {
  Axios.all(promises).then(Axios.spread(success))
}

export default {
  post,
  get,
  all
}



// WEBPACK FOOTER //
// ./src/common/network/http.js